export default "__VITE_ASSET__BWlDW8EG__"